import React from "react";
import useBreadcrumbs from "use-react-router-breadcrumbs";
import { EuiHeaderBreadcrumbs } from "@elastic/eui";
import _ from "lodash";
import { useHistory } from "react-router-dom";
import { FormattedMessage } from "react-intl";

function Breadcrumbs() {
    const breadcrumbs = useBreadcrumbs(null, { excludePaths: ["/database"] });
    const history = useHistory();
    const bcs = [];

    const handleMatchedUrl = (match) => {
        if (match.url === "/clientProjects" || match.url === "/database/clientProjects") {
            if (history?.location?.state?.clientId) {
                history.push({
                    pathname: `/database/clients/${history?.location?.state?.clientId}`,
                    state: { entityName: history.location?.state?.entityName },
                });
            } else {
                history.push("/database/projects");
            }
        } else {
            history.push(match.url);
        }
    };
    breadcrumbs.forEach(({ match, breadcrumb }) => {
        const localizedText = !isNaN(breadcrumb.props.children) ? (
            <FormattedMessage
                id="layout.number"
                values={{ value: `${breadcrumb.props.children}` }}
            />
        ) : (
            <FormattedMessage id={`layout.${_.kebabCase(breadcrumb.props.children)}`} />
        );
        bcs.push({
            text: localizedText,
            onClick: () => {
                handleMatchedUrl(match);
            },
        });
    });
    return (
        <EuiHeaderBreadcrumbs
            breadcrumbs={bcs}
            truncate={false}
        />
    );
}

export default Breadcrumbs;
